import config from '../../../configuration/configuration.js';
import AxiosRequest from '../../../utils/AxiosRequest';

export const ExportSitesRequest = () => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}SiteTracker/ExportSites`,
});
